import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPaintbrush12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPaintbrush12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Paintbrush12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m10.328 3.157-.707.707L8.207 2.45l.707-.707a1 1 0 1 1 1.414 1.414M7.5 1.743l.707-.707a2 2 0 1 1 2.829 2.828l-.708.707 1.061 1.06a1.5 1.5 0 0 1 0 2.122l-1.06 1.06a1 1 0 0 1-1.415 0l-2.828 2.83a1 1 0 0 1-1.414 0L.429 7.398a1 1 0 0 1 0-1.414l2.828-2.828a1 1 0 0 1 0-1.414L4.318.682a1.5 1.5 0 0 1 2.121 0zm2.121 3.535-.707-.707L7.5 3.157l-.707-.707-1.06-1.06a.5.5 0 0 0-.708 0l-1.06 1.06.707.707 4.242 4.242.707.708 1.061-1.061a.5.5 0 0 0 0-.707zM1.136 6.692l2.828-2.828 4.243 4.243-2.828 2.828-.707-.707 1.11-1.111a.5.5 0 1 0-.706-.707L3.964 9.52 2.55 8.108l.707-.708a.5.5 0 1 0-.707-.707l-.707.707z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Paintbrush12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconPaintbrush12);
